import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import Card from "components/card/Card";
import { useReleaseNotes } from "lib/releaseNoteQueries";
import ReleaseNoteItem from "./ReleaseNoteItem";
import "./ReleaseNotes.scss";

const MAX_CARD_ITEMS = 3;

const WhatsNewCard: FC = () => {
  const { t } = useTranslation();
  const { data, isLoading, isError } = useReleaseNotes();

  // The card is one tile among many on Overview: while it loads, or if the API
  // is unreachable, it stays out of the way rather than showing a broken frame.
  if (isLoading || isError) return null;

  const notes = data ?? [];
  if (notes.length === 0) return null;

  const latest = notes.slice(0, MAX_CARD_ITEMS);

  return (
    <Card customClass="whats-new">
      <div className="whats-new__head">
        <h2 className="modal-title">{t("whatsNew")}</h2>
        <span className="whats-new__version">v{notes[0].version}</span>
      </div>

      <div className="whats-new__list">
        {latest.map((note) => (
          <ReleaseNoteItem key={note.id} note={note} />
        ))}
      </div>

      <Link
        to="/release-notes"
        className="whats-new__all"
        data-testid="view-all-release-notes"
      >
        {t("viewAllReleaseNotes")} <span aria-hidden="true">→</span>
      </Link>
    </Card>
  );
};

export default WhatsNewCard;
